import { types } from '../actions/types';

const INITIAL_STATE = {
    services: null,
    categories: null,
    modules: null,
    activeServices: [],
    pendingServices: [],
    inactiveServices: [],
    customModules: [],
    selectedService: null,
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case types.GET_ALL_SERVICES:
            return {
                ...state, services: action.payload
            }
        case types.GET_ALL_SERVICE_CATEGORIES:
            return {
                ...state, categories: action.payload
            }
        case types.GET_ALL_SERVICE_MODULES:
            return { // DONT USE THIS IS JUST GETS A LIST OF SERVICE MODULES NOT CUSTOMIZED TO THE SERVICE
                ...state, modules: action.payload
            }
        case types.SET_SELECTED_SERVICE_SUCCESS: 
            // console.log('SELECTED SERVICE:', action.payload);
            return {
                ...state, selectedService: action.payload
            }
        case types.SET_SELECTED_SERVICE_FAIL: 
            return {
                ...state, selectedService: action.payload
            }
        case types.ADD_ACTIVE_SERVICE_SUCCESS:
            // console.log('ACTIVE SERVICES',  (state.activeServices && state.activeServices.length > 0) ? [...state.activeServices, action.payload] : [action.payload]);
            return {
                ...state, activeServices: (state.activeServices && state.activeServices.length > 0) ? [...state.activeServices, action.payload] : [action.payload]
            }
        case types.ADD_PENDING_SERVICE_SUCCESS:
            // console.log('PENDING SERVICES',  (state.pendingServices && state.pendingServices.length > 0) ? [...state.pendingServices, action.payload] : [action.payload]);
            return {
                ...state, pendingServices: (state.pendingServices && state.pendingServices.length > 0) ? [...state.pendingServices, action.payload] : [action.payload]
            }
        case types.ADD_INACTIVE_SERVICE_SUCCESS:
            // console.log('INACTIVE SERVICES',  (state.inactiveServices && state.inactiveServices.length > 0) ? [...state.inactiveServices, action.payload] : [action.payload]);
            return {
                ...state, inactiveServices: (state.inactiveServices && state.inactiveServices.length > 0) ? [...state.inactiveServices, action.payload] : [action.payload]
            }
        case types.ADD_CANCELLED_SERVICE_SUCCESS:
            // console.log('INACTIVE SERVICES',  (state.inactiveServices && state.inactiveServices.length > 0) ? [...state.inactiveServices, action.payload] : [action.payload]);
            return {
                ...state, cancelledServices: (state.cancelledServices && state.cancelledServices.length > 0) ? [...state.inactiveServices, action.payload] : [action.payload]
            }
        case types.GET_SERVICE_MODULE_SUCCESS:
            // console.log('INACTIVE SERVICES',  (state.inactiveServices && state.inactiveServices.length > 0) ? [...state.inactiveServices, action.payload] : [action.payload]);
            return {
                ...state, 
                customModules: {
                    ...state.customModules,
                    [action.serviceId]: action.payload
                }
            }
        case types.CLEAR_SERVICE_STATUSES:
            // console.log('INACTIVE SERVICES',  (state.inactiveServices && state.inactiveServices.length > 0) ? [...state.inactiveServices, action.payload] : [action.payload]);
            return {
                ...state, cancelledServices: null, activeServices: null, pendingServices: null, inactiveServices: null
            }
        case types.GET_SERVICE_RATING_FOR_USER_SUCCESS:
            console.log('GOT RATING @ reducer', action.payload);
            
            return {
                ...state, userRating: action.payload
            }
        case types.GET_ALL_SERVICE_RATINGS_SUCCESS:
            return {
                ...state, 
                ratings: {
                    [action.serviceId]: action.payload
                }
            }
        case types.GET_SERVICE_REVIEW_FOR_USER_SUCCESS:
            return {
                ...state, userReview: action.payload
            }
        case types.GET_ALL_SERVICE_REVIEWS_SUCCESS:
            return {
                ...state, 
                reviews: {
                    [action.serviceId]: action.payload
                }
            }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/js/reducers/service-reducer.js